/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

import {
	Modal,
	Button,
	Group,
	Text,
	Box,
	ActionIcon,
	Alert,
} from '@mantine/core';

// Icons
import {
	IconX,
	IconInfoCircle,
} from '@tabler/icons-react';

// Utils
import { addZeroToTenPlace } from '@utils/functions';

// Styles
import classes from './ModalError.module.css';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const ModalError = (props: {
	onConfirm: () => void;
	onClose: () => void;
	onRemove: (data: any) => void;
	opened: boolean;
	data: any;
	type: string;
	message?: string;
}) => {
	/* ******************************* Constants ****************************** */
	const NBR_TOTAL_ITEMS =
		props.data && Array.isArray(props.data)
			? props.data.length
			: 0;
	const { t } = useTranslation();
	/* ******************************** RENDERING ******************************* */

	return (
		<Modal
			opened={props.opened}
			onClose={props.onClose}
			classNames={classes}
			withCloseButton={false}
			size={500}
		>
			<Text className={classes.title}>
				{addZeroToTenPlace(NBR_TOTAL_ITEMS)}{' '}
				{t('errors.missingOrIncorrectData')}
			</Text>
			<Box className={classes.customBody}>
				<Box className={classes.header}>
					<Box className={classes.columnHeader}>
						{t('global.numLine')}
					</Box>
					<Box className={classes.columnHeaderMessage}>
						{t('errors.errorMessage')}
					</Box>
					<Box className={classes.columnCancel}></Box>
				</Box>
				{props.data &&
				Array.isArray(props.data) &&
				props.data.length > 0 ? (
					props.data.map((item: any) => (
						<Box
							key={item.id}
							className={clsx(classes.row)}
						>
							<Box className={classes.column}>
								{item.line}
							</Box>

							<Box className={classes.columnMessage}>
								{item.message}
							</Box>

							<Box className={classes.columnCancel}>
								<ActionIcon
									variant="transparent"
									onClick={() => {
										props.onRemove(item);
									}}
								>
									<IconX
										color="var(--mantine-color-grey)"
										size={'15px'}
									/>
								</ActionIcon>
							</Box>
						</Box>
					))
				) : (
					<Text className={classes.noData}>
						{t('errors.noMessagesAvailable')}
					</Text>
				)}
			</Box>
			<Box
				style={{
					marginTop: '10px',
					marginRight: '15px',
				}}
			>
				<Alert
					icon={<IconInfoCircle />}
					variant="light"
					color="error"
					title={t(
						'errors.unableToAddTheFileToTheDatabase'
					)}
				>
					{props.message}
				</Alert>
			</Box>
			<Box className={classes.containerButtons}>
				<Group mt="xl">
					<Button
						className={classes.button}
						size="sm"
						color="error"
						onClick={() => {
							props.onClose();
						}}
					>
						{t('global.goBackToForm')}
					</Button>
				</Group>
			</Box>
		</Modal>
	);
};
